import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "modal__parking-zone-template-wrapper" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "modal__parking-zone-box"
}
const _hoisted_5 = { class: "modal__parking-zone-count" }
const _hoisted_6 = { class: "modal__subtitle" }
const _hoisted_7 = { class: "modal__parking-zone-count-value" }
const _hoisted_8 = {
  key: 1,
  class: "modal__parking-zone-box"
}
const _hoisted_9 = { class: "modal__parking-zone-count" }
const _hoisted_10 = { class: "modal__subtitle" }
const _hoisted_11 = { class: "modal__parking-zone-count-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translated_text_component = _resolveComponent("translated-text-component")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.descriptionTop)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal__description",
            innerHTML: _ctx.descriptionTop
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.staticParams.PARKING_ZONE_VIEW_ENABLE)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.carParkingSpots || _ctx.carParkingSpots == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_translated_text_component, { translation: "modal_parking_spaces_amount" })
                    ]),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.carParkingSpots), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.freeParkingSpots != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_translated_text_component, { translation: "modal_parking_free_spaces_amount" })
                    ]),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.freeParkingSpots), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}